import React, {useCallback, useMemo} from "react";

import "./shippingFilter.css"
import {useTranslation} from "react-i18next";
import {queries} from "shared/api/queries";
import {removeExistingParamsArrayValue} from "shared/lib/fns";
import {useSearchParams} from "react-router-dom";
import {Checkbox, RangePicker} from "shared/ui";
import {differenceInMinutes, subMinutes} from "date-fns";
import {SellerListType, ShippingSearchParamKey} from "features/shipping/types";
import {useCsvCheckboxFilter} from "features/shipping/hooks/useCsvCheckboxFilter";

interface Props {
  value?: string | null;
  timeStart?: string | null;
  timeEnd?: string | null;
}

const now = new Date();
const DEFAULT_FILTER = {ordering: "name"};
export const SellerTimeFilter = ({value, timeStart, timeEnd}: Props) => {
  const [_, setSearchParams] = useSearchParams();
  const {t} = useTranslation(["shipping"]);
  
  const defaultTime = useMemo(() => {
    const start = timeStart ? subMinutes(now, Number(timeStart)) : now;
    const end = timeEnd ? subMinutes(now, Number(timeEnd)) : now;
    
    return {start, end}
  }, [timeStart, timeEnd]);
  const {
          handleChangeChecked, isLoading, listData, options, selectedValues,
        } = useCsvCheckboxFilter<SellerListType>({
    fetchParams: DEFAULT_FILTER,
    queryKey: ShippingSearchParamKey.shippingShopUuids,
    url: queries.shop.list,
    value,
    toOption: (seller) => ({
      label: seller.name, value: seller.uuid, className: "item",
    }),
    toValue: (seller) => seller.uuid,
  });
  
  const handleFilterByMinute = useCallback((startDate: Date | null, endDate?: Date | null) => {
    let start = 0, end = 0;
    if (startDate && endDate) {
      start = differenceInMinutes(now, startDate);
      end = differenceInMinutes(now, endDate);
    }
    setSearchParams((prev) => ({
      ...removeExistingParamsArrayValue(prev, ShippingSearchParamKey.shippingTimeDiffMinutes, start),
      [ShippingSearchParamKey.shippingTimeDiffMinutes]: start,
      [ShippingSearchParamKey.shippingTimeDiffEndMinutes]: end,
    }));
  }, [setSearchParams]);
  
  return (<div className={"column seller"}>
    <div className={"filter-title"}>
      {t("shop")}
    </div>
    <RangePicker
      startDate={defaultTime.start}
      endDate={defaultTime.end}
      onChange={handleFilterByMinute}
    />
    <Checkbox.Group
      value={selectedValues}
      className={"check-group"}
      options={options}
      onChange={handleChangeChecked}
    />
    {!listData?.length ? (isLoading ? <span>{String(isLoading)}</span> : "데이터가 없습니다") : null}
  </div>);
}
